
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.334 6a3.333 3.333 0 013.333-3.333h6.667A3.333 3.333 0 0114.667 6v3.044a3.333 3.333 0 01-3.333 3.333h-.167v.968c0 1.095-1.245 1.723-2.126 1.072l-2.76-2.04H4.667a3.333 3.333 0 01-3.333-3.333V6zm3.333-2a2 2 0 00-2 2v3.044a2 2 0 002 2h1.834c.142 0 .281.046.396.13l2.937 2.171V11.71c0-.368.299-.666.667-.666h.833a2 2 0 002-2V6a2 2 0 00-2-2H4.667z","fill":"currentColor"}})])
          )
        }
      }
    